import { render, staticRenderFns } from "./AllSubCategories.vue?vue&type=template&id=fc52e672&scoped=true"
import script from "./AllSubCategories.vue?vue&type=script&lang=js"
export * from "./AllSubCategories.vue?vue&type=script&lang=js"
import style0 from "./AllSubCategories.vue?vue&type=style&index=0&id=fc52e672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc52e672",
  null
  
)

export default component.exports